import { render } from "./MyTicket.vue?vue&type=template&id=54d7859e&scoped=true"
import script from "./MyTicket.vue?vue&type=script&lang=js"
export * from "./MyTicket.vue?vue&type=script&lang=js"

import "./MyTicket.vue?vue&type=style&index=0&id=54d7859e&lang=scss&scoped=true"

import exportComponent from "E:\\code\\项目代码\\温州科技馆\\科技馆公众号\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54d7859e"]])

export default __exports__